<template>
  <div>
    <!-- <p style="color:#666">
      <b>Agrupar por</b>
      <el-radio-group v-model="formData.point_type">
        <el-radio-button label="ghe">GHE</el-radio-button>
        <el-radio-button label="funcao">Função</el-radio-button>
      </el-radio-group>
    </p> -->
    <b-table-simple id="table-v0" class="table-v2" small outlined borered>
      <b-thead>
        <b-tr>
          <b-th style="font-size: 7pt !important">{{
            formData.point_type == "ghe" ? "GHE (SETOR)" : "FUNÇÃO"
          }}</b-th>
          <b-th>
            <table width="100%" border="0">
              <tr>
                <td
                  style="
                    font-size: 7pt !important;
                    border: none;
                    background: transparent;
                    color: #fff;
                  "
                  width="80%"
                >
                  AGENTE AVALIADO
                </td>
                <td
                  style="
                    font-size: 7pt !important;
                    border: none;
                    background: transparent;
                    color: #fff;
                  "
                  width="20%"
                >
                  METODOLOGIA
                </td>
              </tr>
            </table>
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-loading="loadingTable">
        <b-tr v-for="(data, i) in tableData" :key="i">
          <b-td
            valign="middle"
            :style="
              'font-size:7pt !important;background:' +
              (i % 2 == 0 ? '#E6E6E6' : '')
            "
          >
            <p v-for="(point, j) in data.points" :key="i + j">
              <el-checkbox
                :label="point.id"
                :disabled="
                  tableMedicaoChecked.length > 0 || data.points.length > 1
                "
                :title="
                  data.points.length > 1
                    ? 'Não é possível agrupar um GHE que já foi agrupado anteriormente'
                    : ''
                "
                v-model="tablePointChecked"
              />

              <span v-if="formData.point_type == 'ghe'">
                {{ point.ghe }} ({{ point.descricao }})
              </span>

              <span v-else-if="formData.point_type == 'funcao'">
                {{ point.nome }}
              </span>
            </p>
          </b-td>
          <b-td :style="'background:' + (i % 2 == 0 ? '#E6E6E6' : '')">
            <table
              width="100%"
              v-for="(orcamento_medicao, j) in data.orcamento_medicoes"
              :key="j"
            >
              <tr>
                <td
                  style="font-size: 7pt !important; background: #f9f6db"
                  width="80%"
                >
                  <el-checkbox
                    v-if="false"
                    :label="orcamento_medicao.id"
                    v-model="tableMedicaoChecked"
                    :disabled="tablePointChecked.length > 0"
                  ></el-checkbox>
                  <b>
                    {{ orcamento_medicao.fator_risco.nome }}
                  </b>
                </td>
                <td
                  style="font-size: 7pt !important; background: #f9f6db"
                  width="20%"
                >
                  <b>{{ orcamento_medicao.fator_risco.cod_metodologia }}</b>
                </td>
              </tr>
              <tr>
                <td style="font-size: 7pt !important; border: none" colspan="2">
                  <div class="row">
                    <div class="col-md-4">
                      Nº DE AMOSTRAGENS
                      <el-input
                        v-model="orcamento_medicao.amostragem"
                        type="number"
                        @change="formataDados()"
                      />
                    </div>

                    <div class="col-md-4">
                      VALOR UNITÁRIO
                      <el-input
                        v-model="orcamento_medicao.valor_venda"
                        v-mask="'money'"
                        type="text"
                        @change="formataDados()"
                      />
                    </div>
                    <div class="col-md-4">
                      VALOR TOTAL
                      <el-input
                        v-model="orcamento_medicao.valor_total"
                        v-mask="'money'"
                        type="text"
                        readonly
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <div class="col-12 text-center">
      <ed-button
        icon="fa fa-save"
        type="success"
        value="Salvar Medições"
        @click="salvar"
      />
      <ed-button
        icon="fa fa-history"
        type="primary"
        title="Clique aqui para restaurar e inicializar o orçamento"
        value="Restaurar Medições"
        @click="restaurar"
      />
      <ed-button
        v-if="tablePointChecked.length > 1"
        icon="fa fa-object-group"
        type="warning"
        title="Clique aqui para agrupar as medições selecionadas"
        :value="'Agrupar ' + this.formData.point_type.toUpperCase()"
        @click="agrupar"
      />
    </div>
  </div>
</template>

<script>
import EdTable from "common/table";
import EdButton from "common/button";
import Rest from "common/rest";

export default {
  name: "exame",
  components: { EdTable, EdButton },
  mixins: [Rest],
  props: {
    orcamento: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "orcamento.id"() {
      this.inicialize();
    },
    "formData.point_type"() {
      this.getLtcatOrcamentoMedicao();
    },
    tableData() {
      this.formataDados();
    },
  },
  data() {
    return {
      formData: {
        point_type: "ghe",
      },
      pagination: {},
      response: {},
      tableData: [],
      tableMedicaoChecked: [],
      tablePointChecked: [],
      loadingTable: false,
      showFormEdit: false,
      showFormCadastro: false,
      showPopover: false,
    };
  },

  created() {},

  mounted: function () {
    this.getLtcatOrcamentoMedicao();
    this.inicialize();
  },

  methods: {
    inicialize() {
      if (this.orcamento) {
        this.formData.point_type = this.orcamento.agrupar;
      }
    },

    onRegister: function () {
      this.showFormCadastro = !this.showFormCadastro;
      this.formData = {
        id: 0,
      };
    },

    onEdit: function (data) {
      this.showFormEdit = !this.showFormEdit;
      this.formData = {
        id: data.id,
        descricao: data.descricao,
        tipo_status: data.tipo_status,
        usuario: data.usuario,
        updated_at: data.updated_at,
      };
    },

    formataDados() {
      for (let i = 0; i < this.tableData.length; i++) {
        var data = this.tableData[i];

        for (let j = 0; j < data.orcamento_medicoes.length; j++) {
          var medicao = data.orcamento_medicoes[j];

          var valor_venda = this.moneyToFloat(medicao.valor_venda),
            amostragem = parseInt(medicao.amostragem);

          medicao.valor_venda = this.floatToMoney(valor_venda);
          medicao.valor_total = this.floatToMoney(valor_venda * amostragem);
        }
      }
    },

    getLtcatOrcamentoMedicao: function (_search, _page, _pagination) {
      if (!this.$store.state.ltcat.data) return;

      this.loadingTable = true;
      this.response = {};
      this.tableData = [];

      this.get("ltcat/orcamento/medicao/" + this.orcamento.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formData,
      }).then((result) => {
        result = result[0];
        this.response = result;

        if (result.status == 200) {
          this.tableData = result.data;
        }

        this.loadingTable = false;
      });
    },

    restaurar() {
      var self = this;

      this.$confirm(
        "O sistema vai restaurar o orçamento de acordo com o cadastro inicial. Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.loadingTable = true;
        this.response = {};

        this.get(
          "ltcat/orcamento/medicao/" + this.orcamento.id + "/restaurar"
        ).then((result) => {
          result = result[0];
          this.response = result;

          this.loadingTable = false;

          if (result.status == 200) {
            this.getLtcatOrcamentoMedicao();
            this.edMsg("Dados atualizados com sucesso");
            this.$events.fire("orcamentoMedicao." + this.orcamento.id, []);
          }
        });
      });
    },

    agrupar() {
      var self = this;

      this.$confirm(
        "O sistema vai agrupar " +
          this.tablePointChecked.length +
          " " +
          this.formData.point_type.toUpperCase() +
          ". Esse processo NÃO poderá ser desfeito. Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.loadingTable = true;
        this.response = {};

        this.post("ltcat/orcamento/medicao/" + this.orcamento.id + "/agrupar", {
          arrayPoint: this.tablePointChecked,
          filter: this.formData,
        }).then((result) => {
          result = result[0];
          this.response = result;

          this.loadingTable = false;

          if (result.status == 200) {
            this.getLtcatOrcamentoMedicao();
            this.edMsg("Dados atualizados com sucesso");
            this.$events.fire("orcamentoMedicao." + this.orcamento.id, []);
            this.tablePointChecked = [];
          }
        });
      });
    },

    salvar() {
      this.loadingTable = true;
      this.response = {};

      this.post("ltcat/orcamento/medicao/" + this.orcamento.id + "/editar", {
        arrayMedicao: this.tableData,
      }).then((result) => {
        result = result[0];
        this.response = result;

        this.loadingTable = false;

        if (result.status == 200) {
          this.getLtcatOrcamentoMedicao();
          this.edMsg("Dados atualizados com sucesso");
          this.$events.fire("orcamentoMedicao." + this.orcamento.id, []);

          this.tableMedicaoChecked = [];
        }
      });
    },
  },
};
</script>

<style type="scss">
.medicao-agente td {
  background: #ececec;
  font-weight: bold;
}
.medicao-labs td {
  font-size: 7pt !important;
  background: #fff59b;
}
table {
  border-collapse: collapse !important;
}
</style>


// WEBPACK FOOTER //
// medicao.vue?97b32142